module.exports = __webpack_public_path__ + "img/fof_03.ddd23213.png";